import React from 'react';
import { useShopContext } from './ShopContext';

export const ProductCard = ({ product, onClick }) => {
  const { addToCart } = useShopContext();
  
  const handleAddToCart = (e) => {
    e.stopPropagation(); // Prevent clicking through to product detail
    
    if (addToCart) {
      addToCart(product);
      // Show a custom toast notification
      showToast(`${product.name} added to cart`);
    }
  };

  // Custom toast notification function
  const showToast = (message) => {
    const toast = document.createElement('div');
    toast.className = 'fixed top-24 left-1/2 transform -translate-x-1/2 z-50 bg-green-500 text-white px-4 py-2 rounded-md shadow-lg';
    toast.textContent = message;
    document.body.appendChild(toast);
    
    setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transition = 'opacity 0.5s ease';
      
      setTimeout(() => {
        document.body.removeChild(toast);
      }, 500);
    }, 3000);
  };

  return (
    <div 
      className="bg-gray-900 rounded-lg overflow-hidden shadow-lg transition-transform hover:scale-[1.02] cursor-pointer"
      onClick={onClick}
    >
      {/* Product Image */}
      <div className="relative h-48 bg-gradient-to-r from-gray-800 to-gray-900 flex items-center justify-center">
        {product.image ? (
          <img 
            src={product.image} 
            alt={product.name} 
            className="object-contain w-full h-full"
            onError={(e) => {
              e.target.src = 'https://via.placeholder.com/300x200?text=NT+Window+Tinting';
              e.target.onerror = null;
            }}
          />
        ) : (
          <div className="text-center p-4">
            <span className="text-3xl font-bold text-white opacity-30">{product.name}</span>
          </div>
        )}
        
        {/* Discount Badge */}
        {product.discountPrice && (
          <div className="absolute top-2 right-2 bg-red-500 text-white px-2 py-1 rounded text-xs font-bold">
            IZPĀRDOŠANA
          </div>
        )}
      </div>
      
      {/* Product Info */}
      <div className="p-4">
        <div className="flex justify-between items-start mb-2">
          <h3 className="text-lg font-bold text-white">{product.name}</h3>
          
          {/* Rating with SVG star */}
          <div className="flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-yellow-400 mr-1" viewBox="0 0 20 20" fill="currentColor">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
            </svg>
            <span className="text-gray-300 text-sm">{product.rating}</span>
          </div>
        </div>
        
        {/* Price */}
        <div className="flex items-center mb-3">
          {product.discountPrice ? (
            <>
              <span className="text-gray-400 line-through mr-2">€{product.price.toFixed(2)}</span>
              <span className="text-green-400 font-bold">€{product.discountPrice.toFixed(2)}</span>
            </>
          ) : (
            <span className="text-white font-bold">€{product.price.toFixed(2)}</span>
          )}
          
          {product.priceUnit && (
            <span className="text-gray-400 text-sm ml-1">/{product.priceUnit}</span>
          )}
        </div>
        
        {/* Short Description */}
        <p className="text-gray-400 text-sm mb-4 line-clamp-2">
          {product.description}
        </p>
        
        {/* View Details Button - Enhanced styling */}
        <button 
          className="w-full bg-green-400 hover:bg-green-500 active:bg-green-600 text-black font-medium py-2 px-4 rounded transition-all duration-200 transform hover:scale-[1.03] active:scale-[0.98] shadow-md hover:shadow-lg flex items-center justify-center"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
          Sīkāk
        </button>
      </div>
    </div>
  );
}; 